import type { TelefoneBloqueado } from "../../../services/telefonesBloqueados"

export interface TelefoneBloqueadosModel {
    lista: TelefoneBloqueado[]
}

export const TelefoneBloqueadosInicial: TelefoneBloqueadosModel = {
    lista: [],
}
